<template>
  <div>
    <div class="pb-4 d-flex justify-content-between align-items-center">
      <div class="d-flex flex-column">
        <small class="text-muted mb-1">
          <font-awesome-icon
            icon="truck"
            fixed-width
            class="mr-1"
          />
          {{ $t("global.sonstiges") }}
        </small>
        <h1 class="h2">{{ $t("altbestaende.titel") }}</h1>
      </div>
      <!-- <router-link
        :to="{name: 'BearbeiteAltbestaende'}"
        class="btn btn-primary align-self-center"
        v-show="$store.state.isAdmin === 'true' || $store.state.isAdmin"
      >
        <font-awesome-icon
          icon="cog"
          class="mr-2"
        />
        {{ $t("global.ansichtBearbeiten") }}
      </router-link> -->
    </div>
    <div
      class="d-flex mb-4"
      style="gap: 2rem"
    >
      <b-card class="flex-fill">
        <h1>
          {{ formatNumber($store.state.altbestaendeStats.gesamtartikel) }}
        </h1>
        {{ $t("altbestaende.gesamtartikel") }}
      </b-card>
      <b-card class="flex-fill">
        <h1>{{ formatNumber($store.state.altbestaendeStats.kritisch) }}</h1>
        {{ $t("altbestaende.kritisch") }}
      </b-card>
      <b-card class="flex-fill">
        <h1>{{ formatNumber($store.state.altbestaendeStats.warnung) }}</h1>
        {{ $t("altbestaende.warnung") }}
      </b-card>
      <b-card class="flex-fill">
        <h1>{{ formatCurrency($store.state.altbestaendeStats.gesamtwert) }}</h1>
        {{ $t("altbestaende.gesamtwert") }}
      </b-card>
    </div>
    <b-card
      no-body
      class="shadow-sm"
    >
      <altbestaende-tabelle></altbestaende-tabelle>
    </b-card>
  </div>
</template>

<script>
  import AltbestaendeTabelle from "./AltbestaendeTabelle.vue";
  export default {
    name: "AltbestaendeReiter",
    components: {
      AltbestaendeTabelle,
    },
    created() {
      // Lade Altbestände beim Erstellen der Komponente
      console.log("AltbestaendeReiter - created() aufgerufen");
      this.$store.dispatch("fetchAltbestaende");
    },
    methods: {
      formatCurrency(value) {
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
          maximumFractionDigits: 0,
        }).format(value || 0);
      },
      formatNumber(value) {
        return new Intl.NumberFormat("de-DE").format(value || 0);
      },
    },
  };
</script>
